import Header from '../components/Header';
import Footer from '../components/footer';
import GalleryNav from '../components/GalleryNav';
import Swipper from '../components/swiper';
import GalleryStatsBar from '../components/GalleryStatsBar';



function Gallery(props) {
  return (
    (<>
      <Header />
      <div className='container text-center alii' style={{ paddingTop: 15 }}>
        <GalleryNav activeKey="gallery" />
        <div className='page-header'>
          <h1 className='section-title'>المعرض</h1>
        </div>
      </div>
      <p style={{ paddingTop: 20 }}>  </p>
      <div className='container mb-3'>
        <GalleryStatsBar />
      </div>
      <div className='container mxwhd'>
        <Swipper />
      </div>
      <Footer />
    </>)
  );
}

export default Gallery;